/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type InvitationStatus = 'Unknown' | 'Pending' | 'Canceled' | 'Redeemed' | 'Expired';

export const InvitationStatus = {
    Unknown: 'Unknown' as InvitationStatus,
    Pending: 'Pending' as InvitationStatus,
    Canceled: 'Canceled' as InvitationStatus,
    Redeemed: 'Redeemed' as InvitationStatus,
    Expired: 'Expired' as InvitationStatus
};